import React from 'react';

function Test() {
  return <h1>TESTING</h1>;
}

export default Test;
